import React, { useRef } from 'react';
import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchRef,
} from 'react-zoom-pan-pinch';
import ModalComponent from '../../components/ModalComponent';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import CloseIcon from '../../assets/img/close.svg';
import { API_STATUS, KYC_DOCUMENT_STATUS } from '../../utils/Constant';
import CenterSpinner from '../../components/CenterSpinner';
import { updateKYCDocumentStatusSelector } from '../../features/onboardingSlice';
import { DocumentType } from '../../utils/Types';
import { useAppSelector } from '../../store/redux-hooks';

interface IImagePreviewProps {
  isOpen: boolean;
  toggle: (value: any | undefined) => void;
  selectedDocument?: DocumentType;
  photoURL: string | null | undefined;
  isItUrl?: boolean;
  onApproveRejectAction: (actionType: number, documentId: number) => void;
}
const Controls = ({ zoomIn, zoomOut, resetTransform }: any) => (
  <div className="d-flex">
    <div className="bd-highlight">
      <Button variant="light" className="m-1" onClick={() => zoomIn()}>
        +
      </Button>
      <Button variant="light" className="m-1" onClick={() => zoomOut()}>
        -
      </Button>
      <Button variant="light" className="m-1" onClick={() => resetTransform()}>
        x
      </Button>
    </div>
  </div>
);
const ImagePreviewModal: React.FunctionComponent<IImagePreviewProps> = ({
  isOpen,
  toggle,
  photoURL,
  isItUrl,
  selectedDocument,
  onApproveRejectAction,
}) => {
  const updateStatus = useAppSelector(updateKYCDocumentStatusSelector);
  const transformComponentRef = useRef<ReactZoomPanPinchRef | null>(null);

  const generateChildren = () => {
    return (
      <TransformWrapper
        initialScale={1}
        initialPositionX={0}
        initialPositionY={0}
        ref={transformComponentRef}
      >
        {(utils) => (
          <React.Fragment>
            <Controls {...utils} />
            <TransformComponent>
              {isItUrl ? (
                <Image
                  src={`${photoURL}`}
                  alt={selectedDocument?.documentType}
                  id="imgPreview1"
                  className="preview-image"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                />
              ) : (
                <Image
                  src={`data:image/png;base64, ${photoURL}`}
                  alt={selectedDocument?.documentType}
                  id="imgPreview2"
                  className="preview-image"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                />
              )}
            </TransformComponent>
          </React.Fragment>
        )}
      </TransformWrapper>
    );
  };
  const getChildren = () => (
    <div className="d-flex justify-content-center">
      <div className="preview-modal">
        <div className="d-flex justify-content-end">
          <Image src={CloseIcon} className="next-prev-icon" onClick={toggle} />
        </div>
        <div id="imageViewParent" className="d-flex justify-content-center">
          <div className="mx-3">
            <div className="preview-image-parent">{generateChildren()}</div>
            {selectedDocument?.documentStatus ===
              String(KYC_DOCUMENT_STATUS.UPLOADED) && (
              <div className="d-flex justify-content-center">
                <Button
                  variant="primary"
                  className="btn-image-preview bg-green"
                  onClick={() => {
                    onApproveRejectAction(
                      KYC_DOCUMENT_STATUS.APPROVED,
                      selectedDocument?.documentId ?? -1
                    );
                  }}
                >
                  Approve
                </Button>
                <Button
                  variant="primary"
                  className="ms-2 btn-image-preview bg-yellow"
                  onClick={() => {
                    onApproveRejectAction(
                      KYC_DOCUMENT_STATUS.REJECT,
                      selectedDocument?.documentId ?? -1
                    );
                  }}
                >
                  Reject
                </Button>
              </div>
            )}
          </div>
        </div>
        <CenterSpinner
          showLoader={updateStatus.status === API_STATUS.LOADING}
        />
      </div>
    </div>
  );
  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={toggle}
      className="modalWrapper"
      backdrop={true}
    >
      {getChildren()}
    </ModalComponent>
  );
};
export default ImagePreviewModal;
